module.exports = __webpack_public_path__ + "static/img/tutorial-normal-competitiveness-4.82792dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-normal-competitiveness-4.jpg
// module id = urdl
// module chunks = 3